// extracted by mini-css-extract-plugin
export default {"wrap":"L7CMK","inline":"FYL8d","withMarginRight":"EqYrS"};